
import React from "react";
import "./App.css";
import "./assets/css/ledgerdetail.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Admin from "./components/Admin";
import BillPreview from "./components/BillPreview";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import Dashboard from "./components/Dashboard";
import Login from "./pages/auth/SignIn";
import ResetPassword from "./pages/auth/ResetPassword";
import UpdatePassword from "./pages/auth/UpdatePassword";
import Register from "./pages/auth/Register";
import { useEffect , useState} from "react";
import Loader from "./components/components/Loader";
import { Box } from "@mui/material";
import { ClipLoader } from "react-spinners";
import { getTrial, handleLoading } from "./pages/trial/trialSlice";
import PublicStore from "./pages/my store/PublicStore";
import MyCart from "./pages/my store/MyCart";
import LandingPage from "./pages/landing page";
import Terms from "./pages/landing page/TermsConditions";
import About from "./pages/landing page/About";
import InventoryModule from "./pages/landing page/modules/InventoryModule";
import PosModule from "./pages/landing page/modules/PosModule";
import MobileAppModule from "./pages/landing page/modules/MobileAppsModule";
import FinancialModule from "./pages/landing page/modules/FinancialModule";
import HRModule from "./pages/landing page/modules/HRModule";
import DeliveryModule from "./pages/landing page/modules/DeliveryModule";
import StoreModule from "./pages/landing page/modules/StoreModule";
// import Pricing from "./pages/landing page/Pricing";
import Repo from "./Repository/Repo";
import { Redirect, useHistory } from "react-router-dom";
import Pricing from "./pages/landing page/Pricing/index";

function App() {
  const dispatch = useDispatch();
  const { loading, status,  trialExpired } = useSelector((state) => state.trial);
  // const [isOnline, setIsOnline] = useState(navigator.onLine);
  let token = localStorage.getItem("tokenType");
  const history = useHistory();

  console.log("helloo000000,",token);
  console.log("loading,",loading);

  console.log("status,",status);
  // useEffect(() => {
  //   fetch("https://get.geojs.io/v1/ip/geo.json")
  //     .then((response) => response.json())
  //     .then((data) => localStorage.setItem("data",data.country_code3))
  //     .catch((error) => console.error("Error fetching location:", error));
  // }, []);



  // const updateOnlineStatus = () => {
  //   setIsOnline(navigator.onLine);
  // };
 
  // useEffect(() => {
  //   window.addEventListener('online', updateOnlineStatus);
  //   window.addEventListener('offline', updateOnlineStatus);

  //   // Cleanup function to remove the event listeners when the component unmounts
  //   return () => {
  //     window.removeEventListener('online', updateOnlineStatus);
  //     window.removeEventListener('offline', updateOnlineStatus);
  //   };
  // }, []);
  useEffect(() => {

      if (token == "admin" && localStorage.getItem("email")) {
        if (status == "Trial Ended" &&   trialExpired) {  
          console.log('enddddddd')
           localStorage.clear();
           history.push("/inventory/login");

        } else {
          console.log('gettrail', )

            dispatch(getTrial());
          
  
        }
      } else {
        if(localStorage.getItem("email")) {
          dispatch(getTrial());
        }else {
          dispatch(handleLoading());

        }
      
      }

      console.log('handleLoading', loading)
      
      dispatch(handleLoading());
  }, [status]);

  useEffect(() => {

 
      console.log('ig',)
      if (token) {
        fetchTemplate();
      }

  }, [token]);

  const fetchTemplate = () => {
    Repo.template({
      request: {
        method: "getTemplate",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    })
    .then(({ data }) => {
      localStorage.setItem("template", data.response.data.template);
    })
    .catch((error) => {
      console.error("Error fetching template:", error);
    });
  };
  

  return (
    <>
      {loading && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <ClipLoader size={100} color="#4DAF51" loading={true} />
        </Box>
      )}
      {!loading && (
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <div className="component-background">
              <div>
                {token == "admin" && (status == "Trial" || status == "Paid") ? (
                  <Switch>
                    <Route
                      exact
                      path="/inventory/admin/store/:id"
                      component={PublicStore}
                    />
                    <Route exact path="/store/:id" component={PublicStore} />
                    <Route exact path="/store/:id/cart" component={MyCart} />
                    <Route
                      exact
                      path="/inventory/bill-preview"
                      component={BillPreview}
                    />
                    <Route
                      exact
                      path="/inventory/bill-preview/:id"
                      component={BillPreview}
                    />
                    <Route path="/*" component={() => <Admin lang="eng" />} />
                  </Switch>
                ) : token === "user" &&
                  (token == "user" || status == "Trial" || status == "Paid") ? (

                  <Switch>
                    <Route
                      path="/inventory/dashboard"
                      
                      component={() => <Dashboard lang="eng"   />}
                    />
                    <Route
                      path="/inventory/dashboard/outgoing/outgoingpurchase"
                      component={() => <Dashboard lang="eng"   />}
                    />
                       <Route
                      path="/inventory/purchase-order/finalized"
                      component={() => <Dashboard lang="eng"   />}
                    />
                  
                    
                    <Route
                      exacts
                      path="/inventory/admin/store/:id"
                      component={PublicStore}
                    />
                    <Route exact path="/store/:id" component={PublicStore} />
                    <Route exact path="/store/:id/cart" component={MyCart} />

                  </Switch>
                ) : (
                  <Switch>
                    <Route exact path="/store/:id" component={PublicStore} />

                    <Route exact path="/store/:id/cart" component={MyCart} />

                    <Route
                      exact
                      path="/terms-and-conditions"
                      component={Terms}
                    />
                    <Route
                      exact
                      path="/inventory/bill-preview"
                      component={BillPreview}
                    />
                    <Route
                      exact
                      path="/inventory/bill-preview/:id"
                      component={BillPreview}
                    />
                    <Route exact path="/inventory/login" component={Login} />
                    <Route
                      exact
                      path="/inventory/Signup"
                      component={Register}
                    />
                    <Route
                      exact
                      path="/reset-password"
                      component={ResetPassword}
                    />
                    <Route
                      path="/resetlink/:id/:code"
                      component={UpdatePassword}
                    />
                    <Route exact path="/inventory" component={LandingPage} />
                    <Route exact path="/about-us" component={About} />
                    <Route exact path="/pricing" component={Pricing} />
                    <Route
                      exact
                      path="/features/inventory-module"
                      component={InventoryModule}
                    />
                    <Route
                      exact
                      path="/features/pos-module"
                      component={PosModule}
                    />
                    <Route
                      exact
                      path="/features/mobile-apps-module"
                      component={MobileAppModule}
                    />
                    <Route
                      exact
                      path="/features/financial-module"
                      component={FinancialModule}
                    />
                    <Route
                      exact
                      path="/features/delivery-module"
                      component={DeliveryModule}
                    />
                    <Route
                      exact
                      path="/features/online-store-module"
                      component={StoreModule}
                    />
                    <Route
                      exact
                      path="/features/hr-module"
                      component={HRModule}
                    />
                    <Route exact path="/" component={LandingPage} />
                    {/* <Route exact path="/pricing" component={Pricing} /> */}
                    {/* <Route exact path="/*" component={Login} /> */}
                    <Route path="/*" component={() => <Admin lang="eng" />} />
                    
                  </Switch>
                )}
              </div>
              <div></div>
            </div>
          </Router>
        </PersistGate>
      )}
    </>
  );
}

export default App;










































